export const mainDataArray = () => [
  {
    id: "itemNumber",
    name: "itemNumber",
    type: "number",
    label: "Item",
    displayOnly: true,
  },
  {
    id: "higherLevelItem",
    name: "higherLevelItem",
    type: "number",
    label: "Higher Level Item",
  },
  {
    id: "itemCategoryId ",
    name: "itemCategoryId ",
    type: "text",
    label: "Item Cat",
  },
];
export const enhancedInputArray = () => [
  {
    id: "materialId",
    name: "materialId",
    label: "Material",
    type: "text",
    tag: "enhancedInput",
  },
];
export const quantityArray = ({ dropDowns }) => [
  {
    id: "quantity",
    name: "quantity",
    label: "Quantity",
    type: "number",
  },
  {
    id: "unitId",
    name: "unitId",
    label: "Unit",
    type: "text",
    tag: "select",
    options: dropDowns?.qtyUnits || [],
  },
];
export const addQuantityArray = ({ dropDowns }) => [
  {
    id: "quantity1",
    name: "quantity1",
    label: "Additional Quantity",
    type: "number",
  },
  {
    id: "unit1Id",
    name: "unit1Id",
    label: "Unit",
    type: "text",
    tag: "select",
    options: dropDowns?.qtyUnits || [],
  },
];
